export default __webpack_public_path__ + "static/media/Tovar.25b3743c.png";